// extracted by mini-css-extract-plugin
export default {"container":"TheFirst_container__kmcpC","textBlock":"TheFirst_textBlock__O4vq9","button":"TheFirst_button__SNi5D"};